import { useEffect } from 'react';
import { NavigationBar as CDSNavigationbar } from '@cbhq/cds-web/navigation/NavigationBar';
import { initCastle } from '@cbhq/identity-fingerprint';

import { ErrorBoundary } from './ProfileMenu/components/ErrorBoundary';
import { ClientPropsProvider } from './ProfileMenu/providers/ClientPropsProvider';
import { TopRight } from './TopRight';
import { NavbarProps } from './types';
import { PACKAGE_VERSION_NAME } from './version';

export function NavigationBar(clientProps: NavbarProps) {
  const { castlePublishableKey, paddingTop, paddingBottom, bottom, ...restClientProps } =
    clientProps;

  // Opt-in Castle risk tracking: when the host app supplies a publishable
  // key, initialize the SDK so the profile-menu sign-out request carries a
  // Castle token via getCastleToken. Skipped entirely when no key is provided
  // so the Castle SDK is never loaded for hosts that don't opt in.
  useEffect(() => {
    if (!castlePublishableKey) {
      return;
    }
    initCastle({ publishableKey: castlePublishableKey });
  }, [castlePublishableKey]);

  return (
    <ClientPropsProvider profileDropdownProps={clientProps}>
      <ErrorBoundary fallback={clientProps.boundaryFallback}>
        <CDSNavigationbar
          {...restClientProps}
          bottom={bottom}
          // 8px vertical padding keeps the 72px navbar spec with TopRight's 56px
          // minHeight (added for focus-ring clipping in IDFE-2312).
          paddingTop={paddingTop ?? 1}
          paddingBottom={bottom ? paddingBottom : paddingBottom ?? 1}
          end={<TopRight />}
          data-version={PACKAGE_VERSION_NAME}
        >
          {clientProps.children}
        </CDSNavigationbar>
      </ErrorBoundary>
    </ClientPropsProvider>
  );
}
